<template>
  <div class="box">
    <div class="header">
      <el-header class="Homeboxtop">
        <div class="header-left">
          <div class="Homeboxtopleft">
            <div style="width: 40px; height: 40px; margin-top: -3px">
              <img style="width: 40px; height: 40px" src="./img/login.svg" />
            </div>
            <div class="header-title">
              <span>督导半月报</span>
            </div>
          </div>
        </div>
        <div class="Homeboxtopright">
          <div style="margin-top: -10px; margin-right: 12px" class="UserAvatar">
            <img src="./img/user.jpg" alt="" />
          </div>
          <div style="margin-top: -20px">你好，管理员</div>
          <div class="close_img">
            <img src="./img/close.png" alt="" @click="loginOut" />
          </div>
        </div>
      </el-header>
    </div>
    <div class="container">
      <div v-if="tableShow" class="box_title">
        <div class="hearder_title">武昌区“双减”工作专项督导半月报</div>
        <div class="hearder_selectDate">
          <div class="hearder_selectDate_tool">上一周期</div>
          <div class="hearder_selectDate_time">
            <el-select
              v-model="queryParams.date"
              clearable
              placeholder="请选择日期"
              class="label"
            >
              <el-option
                v-for="item in list"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="hearder_selectDate_tool">下一周期</div>
        </div>
      </div>
      <div v-else class="box_title">
        <div @click="back" class="box_title_back">
          <img src="./img/back.png" alt="" /> <span>返回</span>
        </div>
        <div class="hearder_title_info">建立作业公示制度学校详情</div>
        <div class="hearder_selectDate">
          <span>2022年2月下半月</span>
        </div>
      </div>
      <div v-if="tableShow" class="class-table">
        <div class="table-wrapper">
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th style="width:200px">督导内容项目</th>
                  <th style="width:500px"></th>
                  <th>数量</th>
                  <th>占比</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="6">基本情况</td>
                  <!-- <td>县、区总数</td>
                  <td>16</td>
                  <td>——</td> -->
                </tr>
                <tr>
                  <td>义务教育阶段学校总数</td>
                  <td>62</td>
                  <td>——</td>
                </tr>
                <tr>
                  <td>必须开展课后服务的学校总数</td>
                  <td>62</td>
                  <td>——</td>
                </tr>
                <tr>
                  <td>义务教育阶段学科类校外培训机构总数</td>
                  <td>18</td>
                  <td>——</td>
                </tr>
                <tr>
                  <td>线上机构数量</td>
                  <td>9</td>
                  <td>——</td>
                </tr>
                <tr>
                  <td>线下机构数量</td>
                  <td>9</td>
                  <td>——</td>
                </tr>
                <tr>
                  <td rowspan="3">作业管理情况</td>
                  <td>建立作业校内公示制度学校</td>
                  <td><span class="canClick" @click="click">31</span></td>
                  <td>50%</td>
                </tr>
                <tr>
                  <td>作业时间控制达标学校</td>
                  <td class="canClick" @click="click">22</td>
                  <td>35.48%</td>
                </tr>
                <tr>
                  <td>不给家长布置作业或要求家长批改作业的学校</td>
                  <td class="canClick" @click="click">27</td>
                  <td>44%</td>
                </tr>
                <tr>
                  <td rowspan="3">课后服务开展情况</td>
                  <td>提供课后服务的学校</td>
                  <td class="canClick" @click="click">50</td>
                  <td>81%</td>
                </tr>
                <tr>
                  <td>服务时间达标的学校</td>
                  <td class="canClick" @click="click">43</td>
                  <td>69%</td>
                </tr>
                <tr>
                  <!-- <td>建立经费保障机制的县（区）</td>
                  <td class="canClick" @click="click">3</td>
                  <td>11.11%</td> -->
                </tr>
                <tr>
                  <td rowspan="3">校外培训机构审批情况</td>
                  <td>统一登记为非营利性机构的学科类校外培训机构（线下）</td>
                  <td class="canClick" @click="click">2</td>
                  <td>6.9%</td>
                </tr>
                <tr>
                  <td>由备案改为审批的学科类校外培训机构（线上）</td>
                  <td class="canClick" @click="click">2</td>
                  <td>6.9%</td>
                </tr>
                <tr>
                  <td>学科类校外培训机构压减数量</td>
                  <td class="canClick" @click="click">2</td>
                  <td>6.90%</td>
                </tr>

                <tr>
                  <td rowspan="3">校外培训监管情况</td>
                  <td>
                    占用国家法定节假日、休息日及寒暑假组织义务教育阶段学科类培训的机构
                  </td>

                  <td class="canClick" @click="click">2</td>
                  <td>7.41%</td>
                </tr>
                <tr>
                  <td>
                    清理占用国家法定节假日、休息日及寒暑假组织义务教育阶段学科类培训机构的完成数量
                  </td>

                  <td class="canClick" @click="click">6</td>
                  <td>11%</td>
                </tr>
                <tr>
                  <td>全面使用示范合同文本的义务教育阶段学科类培训机构</td>
                  <td class="canClick" @click="click">9</td>
                  <td>50%</td>
                </tr>
                <tr>
                  <td rowspan="2">校外培训预收费监管情况</td>
                  <td>执行政府指导价的义务教育阶段学科类校外培训机构</td>
                  <td class="canClick" @click="click">0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td>培训预收费有效实行风险管控的学科类校外培训机构</td>
                  <td class="canClick" @click="click">9</td>
                  <td>50%</td>
                </tr>
                <tr>
                  <td rowspan="2">培训广告管控情况</td>
                  <!-- <td>
                    严格执行义务教育阶段学科类校外培训广告管控措施的县、区
                  </td>
                  <td class="canClick" @click="click">13</td>
                  <td>100%</td> -->
                </tr>
                <tr>
                  <td>查处义务教育阶段学科类校外培训违规广告</td>
                  <td class="canClick" @click="click">0</td>
                  <td>——</td>
                </tr>
                <tr>
                  <td rowspan="2">举报查处情况</td>
                  <td>省级教育部门接到群众举报“双减”问题线索总数</td>
                  <td class="canClick" @click="click">4</td>
                  <td>——</td>
                </tr>
                <tr>
                  <td>省级教育部门接到群众举报“双减”问题线索数量</td>
                  <td class="canClick" @click="click">4</td>
                  <td>100%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-else class="class-table">
        <div class="table-wrapper">
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th>武汉外国语学校小学部</th>
                  <th>填报时间</th>
                  <th>是否建立作业公示制度</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableData" :key="index">
                  <td>
                    {{ item.schoolName }}
                  </td>
                  <td>
                    {{ item.time }}
                  </td>
                  <td>
                    {{ item.status }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="pagination">
            <el-pagination
              background
              :current-page="page.pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="page.pageSize"
              :total="page.totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="foot">
        <div class="foot_left">
            <div class="foot_top">
                 <span>主办：武汉市教育局</span>
                 <span>技术运营支持：天喻教育科技有限公司</span>
            </div> 
            <div class="foot_bottom">
                <span>© 2021 wuhaneduyun.cn . All Rights Reserved.   鄂ICP备13001992号-14</span>
            </div> 
        </div>
        <div class="foot_right">
             <span>站长统计</span> <span>帮助反馈</span>
        </div>
    </div> -->
  </div>
</template>
<script>
// import api from '@/api/wisdomSchool/index.js'
export default {
  data() {
    return {
      queryParams: {
        date: "2022年3月上半月",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 10,
      },
      tableShow: true,
      list: [
        { id: "1", label: "2022年3月上半月", value: "1" },
        { id: "2", label: "2022年2月上半月", value: "2" },
        { id: "3", label: "2022年2月下半月", value: "3" },
        { id: "4", label: "2022年1月上半月", value: "4" },
        { id: "5", label: "2022年1月下半月", value: "5" },
      ],
      tableData: [
        { schoolName: "武汉外国语学校小学部", time: "2022-2-16", status: "是" },
        { schoolName: "武汉市育才小学 ", time: "2022-2-16", status: "是" },
        {
          schoolName: "湖北省武昌水果湖第一小学",
          time: "2022-2-19",
          status: "是",
        },
        { schoolName: "武汉小学", time: "2022-2-20", status: "是" },
        { schoolName: "华中师范大学附属小学", time: "2022-2-18", status: "是" },
        { schoolName: "武昌实验小学", time: "2022-2-12", status: "是" },
        { schoolName: "武汉大学第一附属小学", time: "2022-2-24", status: "是" },
        {
          schoolName: "武汉市硚口区崇仁路小学",
          time: "2022-2-19",
          status: "是",
        },
        { schoolName: "武汉市育才第二小学", time: "2022-2-15", status: "是" },
        { schoolName: "武汉市光谷第一小学", time: "2022-2-22", status: "是" },
      ],
    };
  },
  watch: {},
  mounted() {},
  created() {
    this.getDataList();
  },
  methods: {
    async getDataList() {
        document.title='督导半月报'
    },
    click() {
      console.log("点击了");
      this.tableShow = false;
    },
    back() {
      this.tableShow = true;
    },
    loginOut() {},
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.box {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: #f8f8f8;
  display: flex;
  // justify-content: center;
  align-items: center;
  flex-direction: column; /*使元素垂直排列*/
  .header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    .header-title {
      height: 42px;
      margin-left: 12px;
      line-height: 52px;
      color: #000;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 17px;
    }
    .Homeboxtop {
      //   border-bottom: 1px solid #ddd;
      height: 88px !important;
      line-height: 88px;
      display: flex;
      justify-content: space-between;
      .Homeboxtopleft {
        height: 100%;
        padding-right: 800px;
        display: flex;
        justify-content: flex-start;
        vertical-align: middle;
        height: 44px;
        // border-right: 1px solid #dcdcdc;
        margin-top: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .Homeboxtopright {
        height: 44px;
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        padding-left: 15px;
        .UserAvatar {
          width: 30px;
          height: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .close_img {
          display: inline-block;
          width: 60px;
          height: 30px;
          padding-left: 20px;
          margin-top: 9px;
          margin-left: 20px;
          border-left: 2px solid #dcdcdc;
          cursor: pointer;
          img {
            width: 22px;
            height: 22px;
            margin-bottom: 23px;
          }
        }
        div:nth-child(1) {
          margin-top: -50px;
        }
        img {
          border-radius: 50%;
        }
      }
    }
    ::v-deep .el-icon-arrow-left {
      margin-top: 42px;
    }
    ::v-deep .el-icon-arrow-right {
      margin-top: 42px;
    }
  }

  .container {
    width: 1194px;
    background-color: #fff;
    margin: 2% 0 7% 0;
    padding: 20px;
    .box_title {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 16px 0px;
      .box_title_back {
       
        cursor: pointer;
        span {
          margin-left: 10px;
          font-family: PingFang SC;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */
          color: #8b8b8b;
        }
      }
      .hearder_title {
        margin-left: 34%;
        font-family: Pi ngFang SC;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 25px;
        color: #000000;
      }
      .hearder_title_info {
         margin: 0 25% 0 38%;
        font-family: Pi ngFang SC;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 25px;
        color: #000000;
      }
      .hearder_selectDate {
        margin-right: 3%;
        display: flex;
        .hearder_selectDate_tool {
          width: 76px;
          height: 40px;
          cursor: pointer;
          background: #4991e1;
          border-radius: 4px 4px 4px 4px;
          color: #fff;
          text-align: center;
          line-height: 40px;
        }
        .hearder_selectDate_time {
          margin: 0 10px;
        }
      }
    }
    .class-table {
      width: 100%;
      background-color: #fff;
      table,
      table tr th,
      table tr td {
        border: 1px solid #ECECEC;
        padding: 5px;
      }
      table {
        min-height: 25px;
        line-height: 25px;
        text-align: center;
        border-collapse: collapse;
      }
      .table-wrapper {
        width: 100%;
        height: 100%;
        overflow: auto;
        .pagination {
          margin: 30px 38%
        }
      }
      .table-container {
        table {
          table-layout: fixed;
          width: 100%;

          thead {
            height: 70px;
            background-color: #efefef;
            th {
            //   font-weight: bold;
              font-size: 14px;
              color: #555;
              border: none;
            }
          }
          tbody {
            td {
            //   border: 1px solid #ddd;
              width: 600px;
              height: 70px;
              font-family: PingFang SC;
              font-style: normal;
              font-weight: normal;
              font-size: 14px;
              line-height: 20px;
              text-align: center;
              color: #555;
            }
            .canClick {
              width: 10px;
              height: 5px;
              cursor: pointer;
              color: #4991e1;
            }
          }
        }
      }
    }
  }
  .foot{
       width: 1194px;
      height:120px; 
      margin: 50px 0 30px 0;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #555555;  
    .foot_left{
        margin-right: 10%;
    }
  }
}
::v-deep .el-input--suffix .el-input__inner {
  width: 160px;
}
</style>
